// extracted by mini-css-extract-plugin
module.exports = {"recommendationItem":"RecommendationItem_recommendationItem__axKT4"};